import { SocietyUserVar } from "@dune/types";
import {
	Button,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@dune/ui";
import React from "react";
import { useParams } from "react-router-dom";
import { useSetUserAsSignatory } from "../../../../../../api/mutations/societies.mutations";

interface SetSignatoryDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	user: SocietyUserVar;
}

export const SetSignatoryDialog: React.FC<SetSignatoryDialogProps> = ({
	open,
	onOpenChange,
	user,
}) => {
	const { id } = useParams<{ id: string }>();
	const brokerId = Number(id);
	const isCurrentlySignatory = user.isSignatory;

	const { mutate: setUserAsSignatory, isPending } =
		useSetUserAsSignatory(brokerId);

	const handleConfirm = () => {
		setUserAsSignatory(
			{
				brokerId,
				userId: user.id,
				isSignatory: !isCurrentlySignatory,
			},
			{
				onSuccess: () => {
					onOpenChange(false);
				},
			},
		);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>
						{isCurrentlySignatory
							? "Retirer le statut de signataire"
							: "Définir comme signataire"}
					</DialogTitle>
					<DialogDescription>
						{isCurrentlySignatory
							? `Êtes-vous sûr de vouloir retirer le statut de signataire à ${user.firstname} ${user.lastname} ?`
							: `Êtes-vous sûr de vouloir définir ${user.firstname} ${user.lastname} comme signataire de cette société ?`}
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button
						variant="outline"
						onClick={() => onOpenChange(false)}
						disabled={isPending}
					>
						Annuler
					</Button>
					<Button onClick={handleConfirm} disabled={isPending}>
						{isPending ? "..." : isCurrentlySignatory ? "Retirer" : "Confirmer"}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
